import React, { Fragment, useContext, useEffect, useState } from "react";
import { IModalPayload } from "../../constants/common-interface";
import { IOption, IURLLoaderConfig } from "../../constants/model-interfaces";
import FormContext from "../form-context";
import MuiModal from "./MuiModal";

const Modal = (prop: IProps) => {
    const formContext = useContext(FormContext);
    const [open, setOpen] = useState(false);
    const [payload, setPayload] = useState<IModalPayload>();

    const searchIcon = formContext.getIcon("search");

    useEffect(() => {
        const openModalSearchFn = (payload: IModalPayload) => {
            setPayload(payload);
            setOpen(true);
        };
        formContext.listener("open_modalsearch", openModalSearchFn);
        return () => {
            formContext.removeListener("open_modalsearch", openModalSearchFn);
        };
    }, []);

    switch (prop.type) {
        case "mui":
            return (
                <MuiModal
                    open={open}
                    payload={payload}
                    handleChange={(arg: any, options: Array<IOption>) => {
                        if (payload?.valueCallback) {
                            payload.valueCallback(arg);
                            // also update the options
                            formContext.setFieldOptions(payload.section, payload.field, options);
                        }
                        setOpen(false);
                        setPayload(undefined);
                    }}
                    onClose={() => {
                        setOpen(false);
                        setPayload(undefined);
                    }}
                />
            );
        default:
            return <Fragment />;
    }
};

interface IProps {
    type: string;
}

export default Modal;
